{
  "version": 1,
  "asset_id": "8a4ac771-3806-4653-b6a6-f31e39787dd9",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/8a4ac771-3806-4653-b6a6-f31e39787dd9/gallery-10.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/8a4ac771-3806-4653-b6a6-f31e39787dd9/gallery-10.jpeg",
  "original_filename": "gallery-10.jpeg",
  "size": 970324,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:23:03Z"
}
